"use client";
import {
  useCompositeGroup
} from "../__chunks/636A7WVS.js";
import "../__chunks/R2QZ3KXH.js";
import "../__chunks/3X3MDQGM.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/3ORBWXWF.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import "../__chunks/4R3V3JGP.js";

// src/menu/menu-group.ts
var useMenuGroup = createHook((props) => {
  props = useCompositeGroup(props);
  return props;
});
var MenuGroup = createComponent((props) => {
  const htmlProps = useMenuGroup(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  MenuGroup.displayName = "MenuGroup";
}
export {
  MenuGroup,
  useMenuGroup
};
